import { PropsWithChildren } from 'react'
import styled from 'styled-components'

import { createTestId } from 'aem-libs-tests/src/utility/createTestId'

import { Loader, useLoader } from '../../../../common/loader'

export const ResultContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
`

const defaultDelay = 200

export const resultContainerTestId = {
  contentReady: 'content-ready'
}

interface ResultContainer {
  loading?: boolean
  loadingDelay?: number
  testId?: string
}

export const ResultContainer = ({
  children,
  loading,
  loadingDelay = defaultDelay,
  testId
}: PropsWithChildren<ResultContainer>) => {
  const showLoader = useLoader(loading ?? false, loadingDelay)
  const usedTestId = testId ?? 'result-container'

  return (
    <Loader testId={usedTestId} loading={showLoader}>
      <ResultContainerStyled data-testid={createTestId(usedTestId, resultContainerTestId.contentReady)}>
        {children}
      </ResultContainerStyled>
    </Loader>
  )
}
